import React from "react";
import Modal from "react-bootstrap/Modal";
import { FaExclamationTriangle, FaTrashAlt } from "react-icons/fa";

/**
 * DeleteConfirmModal - Reusable confirmation modal for delete operations.
 * Visual design follows the Stitch "Conferma Eliminazione" reference screen
 * (warning-icon header, full-width danger + keep actions, no visible close X).
 */
const ITEM_TYPE_LABELS = {
  scheda: "Scheda",
  note: "Note",
  "categoria-default": "Category",
  item: "Item",
};

const KEEP_LABELS = {
  scheda: "Keep Scheda",
  note: "Keep Note",
  "categoria-default": "Cancel",
  item: "Cancel",
};

const DeleteConfirmModal = ({
  show,
  onHide,
  title,
  itemName,
  itemType = "item", // "scheda" | "note" | "item" | "categoria-default"
  confirmLabel = "Delete",
  onConfirm,
  onCancel,
}) => {
  const heading = `${confirmLabel} ${ITEM_TYPE_LABELS[itemType] || ITEM_TYPE_LABELS.item}`;
  const keepLabel = KEEP_LABELS[itemType] || KEEP_LABELS.item;

  const getWarningText = () => {
    switch (itemType) {
      case "scheda":
        return (
          <>
            Are you sure you want to permanently delete <i>"{itemName}"</i>? This action is{" "}
            <b>irreversible</b> and will remove all its history and associated data.
          </>
        );
      case "note":
        return (
          <>
            Are you sure you want to permanently delete <i>"{itemName}"</i>? This action is{" "}
            <b>irreversible</b>.
          </>
        );
      case "categoria-default":
        return (
          <>
            <i>"{itemName}"</i> is a shared default category. This only hides it from your own
            list — everyone else keeps seeing it, and you can restore it anytime.
          </>
        );
      default:
        return (
          <>
            Are you sure you want to permanently delete <i>"{title || itemName}"</i>? This
            action is <b>irreversible</b>.
          </>
        );
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="delete-modal-content">
      <div className="delete-modal-glow" aria-hidden="true" />
      <Modal.Body className="delete-modal-body">
        <div className="delete-modal-header">
          <div className="delete-modal-icon">
            <FaExclamationTriangle size={18} />
          </div>
          <h2 className="delete-modal-title">{heading} <i>"{title}"</i> </h2>
        </div>

        <p className="delete-modal-text">{getWarningText()}</p>

        <div className="delete-modal-actions">
          <button type="button" className="dashboard-btn-danger-outline" onClick={onConfirm}>
            <FaTrashAlt size={13} />
            {confirmLabel}
          </button>
          <button
            type="button"
            className="dashboard-btn-secondary w-100"
            onClick={onCancel || onHide}
          >
            {keepLabel}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteConfirmModal;
